export const PREPROCESSOR_TYPES = {
  GROUP: 'group',
};

const preprocessors = [];

export const registerPreprocessor = (type, options) => {
  if (!Object.values(PREPROCESSOR_TYPES).includes(type)) {
    throw new Error(`Invalid preprocessor type: ${type}`);
  }

  if (!options.name) {
    throw new Error(`Attempted to register preprocessor without name`);
  }

  if (
    preprocessors.find((preprocessor) => preprocessor.name === options.name)
  ) {
    throw new Error(
      `There is already a preprocessor registered with name: ${options.name}`
    );
  }

  preprocessors.push({
    type,
    ...options,
  });
};

const processGroup = (assemblies, processor) => {
  const result = [];
  const { test, name, component } = processor;

  assemblies.forEach((assembly) => {
    if (test(assembly, assemblies)) {
      const last = result[result.length - 1];
      let group;
      if (last && last.group && last.groupName === name) {
        group = last;
      } else {
        group = {
          group: true,
          groupName: name,
          component,
          items: [],
        };
        result.push(group);
      }
      group.items.push(assembly);
    } else {
      result.push(assembly);
    }
  });

  return result;
};

const processorTypes = {
  [PREPROCESSOR_TYPES.GROUP]: processGroup,
};

const preprocess = (assemblies) =>
  preprocessors.reduce(
    (items, processor) => processorTypes[processor.type](items, processor),
    assemblies
  );

export default preprocess;
